import React from 'react';
import { Link } from 'react-router-dom';
import './Style/Subjects.css';
import subjects from './Subjects';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';


function QuizSubjectPage(props) {



    return (
        <div className="subject-page">

            <TopNavbar name="Mock test" />
            <TopHeader name="Mock test" />



            <div className="subject-categories">

  {/*   <Link to={`/quiz-number/${props.type}/${props.subject}/${props.topic}/${'Full mock test'}`} */}
               <Link to={`/quiz-number/${props.type}/${props.subject}/${props.topic}/${props.subjectName}`}
                    className="subject-card"
                    style={{ borderLeft: `5px solid green` }}
                >
                    <div className="subject-card-header">
                        <div className="subject-icon" style={{ color: "blue" }}>
                            Δ
                        </div>
                        <h2>Full mock test ➔ </h2>
                    </div>

                </Link>

                {subjects.map((subject) => (
                    <Link
                        to={`/${props.link}/${subject.name.toLowerCase().replace(' ', '-')}`}
                        key={subject.id}
                        className="subject-card"
                        style={{ borderLeft: `5px solid ${subject.color}` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: subject.color }}>
                                {subject.icon}
                            </div>
                            <h2>{subject.name} ➔</h2>
                        </div>

                    </Link>
                ))}
            </div>
        </div>


    );
}

export default QuizSubjectPage;